import styled from "styled-components";

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2.4rem;
`;

export const SectionTitle = styled.h3`
    font-size: 1.6rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.titleColor};
`;

export const FiltersSection = styled.form`
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
`;

export const FiltersRow = styled.div`
    display: flex;
    gap: 1.6rem;
    align-items: flex-end;
`;

export const FieldGroup = styled.div<{ $minWidth?: string; $flex?: string, $maxWidth?: string }>`
    display: flex;
    flex-direction: column;
    flex: ${({ $flex }) => $flex || "1"};
    min-width: ${({ $minWidth }) => $minWidth || "200px"};
    max-width: ${({ $maxWidth }) => $maxWidth || "none"};
`;

export const SearchButtonWrapper = styled.div`
    display: flex;
    align-items: flex-end;
    flex: 0 0 auto;
    min-width: 120px;
`;

export const TooltipWrapper = styled.div`
    width: 100%;
`;

export const ResultsSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    flex: 1;
    overflow-y: auto;
    min-height: 0;
`;

export const ResultsTableWrapper = styled.div`
    overflow-x: auto;
    overflow-y: auto;
    max-height: 420px;
    width: 100%;
`;

export const ResultsTitle = styled.h4`
    font-size: 1.4rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.textPrimary};
`;

export const ResultsTable = styled.div`
    border: 1px solid ${({ theme }) => theme.colors.lightItemBorder};
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    min-width: calc(60px + 260px + 180px + 190px + 320px + 180px + 160px);
`;

const GRID_TEMPLATE = "60px 220px 280px 120px 120px 340px 160px";

export const ResultsHeaderRow = styled.div`
    display: grid;
    grid-template-columns: ${GRID_TEMPLATE};
    background: ${({ theme }) => theme.colors.tableThBackground};
    color: ${({ theme }) => theme.colors.textSecondary};
    font-size: 1.2rem;
    font-weight: 600;
    padding: 12px 16px;

    & > span {
    padding: 0 12px;
    text-align: center;
    }

    & > span:nth-child(2),
    & > span:nth-child(3) {
        text-align: left;
    }
`;

export const ResultsRow = styled.div<{ $isOdd?: boolean; $isSelected?: boolean }>`
    display: grid;
    grid-template-columns: ${GRID_TEMPLATE};
    padding: 8px 16px;
    font-size: 1.3rem;
    background: ${({ $isSelected, $isOdd, theme }) =>
        $isSelected ? "rgba(152, 186, 137, 0.35)" : $isOdd ? theme.colors.selectionBlue : theme.colors.componentBackground};

    &:not(:last-child) {
        border-bottom: 1px solid ${({ theme }) => theme.colors.lightItemBorder};
    }
`;

export const ResultsCell = styled.div<{ $align?: "left" | "center" | "right" }>`
    display: flex;
    align-items: center;
    gap: 0.8rem;
    padding: 0 12px;
    min-width: 0;
    max-width: 100%;
    flex: 1 1 auto;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    justify-content: ${({ $align }) =>
        $align === "left" ? "flex-start" : $align === "right" ? "flex-end" : "center"};
    text-align: ${({ $align }) => ($align ? $align : "center")};
`;

export const EllipsisText = styled.span`
    display: block;
    flex: 1 1 auto;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const StatusBadge = styled.span`
    padding: 4px 10px;
    border-radius: 999px;
    background: ${({ theme }) => theme.colors.selectionBlue};
    color: ${({ theme }) => theme.colors.textPrimary};
    font-size: 1.1rem;
    font-weight: 500;
`;

export const ResultsMessage = styled.div`
    padding: 16px;
    border-radius: 12px;
    border: 1px solid ${({ theme }) => theme.colors.lightItemBorder};
    background: ${({ theme }) => theme.colors.componentBackground};
    font-size: 1.3rem;
    color: ${({ theme }) => theme.colors.textSecondary};
`;

export const SelectionInfo = styled.div`
    font-size: 1.2rem;
    color: ${({ theme }) => theme.colors.textSecondary};
`;

export const SelectionWarning = styled.span`
    color: ${({ theme }) => theme.colors.lightOrange};
    font-weight: 600;
`;

export const CheckboxCell = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const StyledCheckbox = styled.input.attrs({ type: "checkbox" })`
    width: 16px;
    height: 16px;
    cursor: pointer;
`;

export const ResultsTableBody = styled.div`
    max-height: none;
    overflow: visible;
    display: flex;
    flex-direction: column;
`;
